module.exports = __webpack_public_path__ + "img/levelup-logo-accestance.dcd41c17.svg";